import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

const SPRING = { type: 'spring', stiffness: 700, damping: 22, mass: 0.6 };

/** Snappy brand-red "back to top" button that appears after scrolling 600px. */
const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          data-testid="back-to-top"
          aria-label="Back to top"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 10 }}
          whileHover={{ scale: 1.1, y: -3 }}
          whileTap={{ scale: 0.92 }}
          transition={SPRING}
          className="fixed bottom-20 right-4 sm:right-6 z-40 w-12 h-12 sm:w-14 sm:h-14 rounded-full btn-red flex items-center justify-center"
          style={{ boxShadow: '0 10px 30px -6px rgba(239,91,91,0.6)' }}
        >
          <ArrowUp className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={2.75} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
